import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUpdateSignedOrderMutation } from 'api/generated/graphql';
import {
  parseOrderEntity,
  parseUpdateSignedOrderParams,
  useError,
} from 'api/helpers';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';
import { UpdateSignedOrderParams } from 'api/types/params';

export const useUpdateSignedOrder = () => {
  const [updateOrder, { loading, error: apolloError }] =
    useUpdateSignedOrderMutation();

  const notifyMessage = useNotifyMessages();

  const error = useError(apolloError);

  return {
    updateSignedOrder: useCallback(
      async (
        id: string,
        versionNumber: number,
        params: UpdateSignedOrderParams
      ) => {
        const input = parseUpdateSignedOrderParams(versionNumber, params);
        const res = await updateOrder({
          variables: {
            id,
            input,
          },
        });

        notifyMessage(res.data?.updateSignedOrder?.messages);

        return res.data?.updateSignedOrder?.data
          ? parseOrderEntity(res.data?.updateSignedOrder.data)
          : null;
      },
      [notifyMessage, updateOrder]
    ),
    loading,
    error,
  };
};
